import { render } from "./App.vue?vue&type=template&id=b0518ab4&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b0518ab4&lang=scss&scoped=true"

import exportComponent from "/home/cosmic/citadel-website/citadel-landing-dao-version-citadelone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0518ab4"]])

export default __exports__